// console.log(document.querySelectorAll('form-embed'));

// (window.formStyles ||= new Map()).set('lunar-form-styles', );

const formMutationObserver = new MutationObserver(function(records) {
	for(const record of records) {
		const copyTextEl = record.target.querySelector('[class*="copyToClipboardText"]');
		if(copyTextEl) {
			const discountCode = copyTextEl.innerText.trim();
			if(discountCode) {
				// document.cookie = `discount_code=${encodeURIComponent(discountCode)}`;
				fetch(`${Shopify.routes.root}discount/${encodeURIComponent(discountCode)}?redirect=%2F%3Fsections%3D`);
				break;
			}
		}
	}
});

const formsBeingObserved = new WeakSet();
function SetupFormObservers() {
	for(const form of document.getElementsByTagName('form-embed')) {
		if(!formsBeingObserved.has(form) && form.shadowRoot) {
			const style = document.createElement('style');
			style.textContent = `
				#app-embed[class*="teaser" i] {
					--container-max-w: 300px;
				}
			`;
			form.shadowRoot.appendChild(style);
			formMutationObserver.observe(form.shadowRoot, {childList: true, subtree: true});
			formsBeingObserved.add(form);
		}
	}
}
SetupFormObservers();
const formBlockMutationObserver = new MutationObserver(SetupFormObservers);
for(const formBlock of document.querySelectorAll('[data-forms-id]')) {
	formBlockMutationObserver.observe(formBlock, {childList: true, subtree: true});
}
